import { Component, ViewChild } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { SalesAdminService } from 'src/app/assabil-sales/services/sales-admin-service';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { RoleProductRate } from 'src/app/assabil-sales/models/entities/role-product-rate';
  
@Component({
  selector: 'role-product-rate',
  templateUrl: './role-product-rate.component.html',
  styleUrls: ['./role-product-rate.component.scss']
})


export class RoleProductRateComponent extends BasePage2<RoleProductRate> {

  @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;

  roleProductRates : RoleProductRate[];

  rootRole          : Role; 
  selectedRole      : Role; 
  roleCode          : string;

  entryMode         : boolean = true;
  enteredOnly       : boolean = false;

  roles             : Role[] = [];


  constructor(
    protected toastr            : ToastrService,
    protected router            : Router,
    protected salesAdminService : SalesAdminService,
    public    masterDataService : MasterDataService,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService, 
    protected location          : Location) { 
       super(toastr, router, baseService, leanUtilsService, location); 
  }


  //----------------------------------------------------------------------
  ngOnInit(){
    
    super.ngOnInit();

    this.init();

    this.masterDataService.personRoleGet('sales').then(result => {
      this.rootRole = result;
    })

  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  init(){
    this.masterDataService.loadProductPages(4, false).then(res => {});
  }

  //----------------------------------------------------------------------
  

  //----------------------------------------------------------------------
  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  //----------------------------------------------------------------------
  

  //----------------------------------------------------------------------
  getRows() : any {
      throw new Error("Method not implemented.");
    }
  //----------------------------------------------------------------------

  
  
  //----------------------------------------------------------------------
  loadData() {
    this.salesAdminService.roleProductRatesGet(this.roleCode).then(roleProductRates => {
      this.setRolesAndProductRates(roleProductRates);
    })
  }
  //----------------------------------------------------------------------


  //----------------------------------------------------------------------
  validate(){
    let roleProductRates : RoleProductRate[] = [];

    for (let pp of this.masterDataService.salableProductPages) {
      for (let product of pp.products) {
        let totalRate = this.getTotalRate(product);
        
        for (let i= 0; i< this.roles.length; i++){
          if (product.rate[i]) {

            if (totalRate != 100) {
              this.leanUtilsService.error("Total des taux est différent de 100 pour : " + product.productCode + " : " + product.name );
              return;
            }
            let roleProductRate : RoleProductRate = new RoleProductRate();
            roleProductRate.product             = new Product();
            roleProductRate.product.productCode = product.productCode;
            roleProductRate.role                = new Role();
            roleProductRate.role.roleCode       = this.roles[i].roleCode;
            roleProductRate.rate                = product.rate[i] ;
            roleProductRates.push(roleProductRate);
          }
        }
      }
    }

    this.salesAdminService.roleProductRatesSave(this.roleCode, roleProductRates).then(roleProductRates => {
      this.setRolesAndProductRates(roleProductRates);
    });
  }
  //----------------------------------------------------------------------


  //----------------------------------------------------------------------
  setRolesAndProductRates(roleProductRates : RoleProductRate[]){
    this.roleProductRates = roleProductRates;


    // this.roles populate
    //--------------------------
    let currentRoleCode = null;
    this.roles = [];
    for (let roleProductRate of this.roleProductRates){
      if (currentRoleCode != roleProductRate.role.roleCode) {
        this.roles.push(roleProductRate.role);
        currentRoleCode = roleProductRate.role.roleCode;
      }
    }
    //--------------------------
 

    // product.rate init
    //--------------------------
    for (let pp of this.masterDataService.salableProductPages) {
      for (let product of pp.products) {
          product.rate = [];
      }
    }
    //--------------------------

    let index = -1;
    currentRoleCode = null;
    for (let roleProductRate of this.roleProductRates){
      if (currentRoleCode != roleProductRate.role.roleCode) {
        currentRoleCode = roleProductRate.role.roleCode;
        index++;
      }

      if (! roleProductRate.product) continue;

      for (let pp of this.masterDataService.salableProductPages) {
        let found = false;
        for (let product of pp.products) {
          if (product.productCode == roleProductRate.product.productCode) {
            product.rate[index] = roleProductRate.rate;      
            found = true;
            break;
          }
        }
        if (found) break;
      }
    }
  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  selectRoleAndGo(role : Role){ 
    this.selectRole(role);
    this.leanDataForm.hideFilter();
    this.loadData();
  }
  selectRole(role : Role){
    if (this.selectedRole != null) this.selectedRole.selected = false;
    this.selectedRole = role;
    this.selectedRole.selected=true;
    this.roleCode = this.selectedRole.roleCode;
  }
  //----------------------------------------------------------------------
  

  //----------------------------------------------------------------------
  getTotalRate(product : Product) : number{
    let res = 0;
    for (let i= 0; i< product.rate.length; i++){
      if (product.rate[i]){
        res += product.rate[i];
      }
    }
    return res;
  }
  //----------------------------------------------------------------------
  
}
